import React from "react";
import { withRouter } from "us.common/wIthRouter";
import { Workflow } from "us.collection/components";

interface ICnt_Workflow {}

const Cnt_Workflow: React.FC<ICnt_Workflow> = (props) => {
  return <Workflow />;
};

export default withRouter(Cnt_Workflow);
